<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="origin-container">
    <div class="fields">
        <p>-</p>
        <p class="bg-gray">Name</p>
        <p>Longitude</p>
        <p>Latitude</p>
        <p class="bg-gray">Distance ({{ unitOfMeasurement }})</p>
        <p *ngIf="layers?.length">Layer</p>
        <p>Height ({{ unitOfMeasurement }})</p>
        <p>Blockage angle</p>
    </div>
    <div class="values">
        <p>
            <span class="badge origin mr-1">{{ ORIGIN_NOTE_BADGE_TEXT }}</span>
            <span *ngIf="hasFreezeLinks" class="badge frozen mr-1">{{ FROZEN_BADGE_TEXT }}</span>
        </p>
        <p class="bg-gray">
            <span>{{ name }}</span>
        </p>
        <p>{{ longitude }}<br/></p>
        <p>{{ latitude }}</p>
        <p class="bg-gray">-</p>
        <p *ngIf="layers?.length">{{ layers[layerIndex].value }}</p>
        <p>{{ height | number: '1.0-1' }} {{ altitudeMode }}</p>
        <p>{{ blockedByPoleAngle }}</p>
    </div>
</div>
